<template>

  <header class="vl-content-header vl-content-header--large vl-content-header--show-mobile vl-content-header--has-context vl-content-header--has-actions">
    <div class="vl-content-header__wrapper">
      <picture class="vl-content-header__bg">
        <img sizes="100vw" src="@/assets/header.png" alt="Content Header">
      </picture>
      <div class="vl-layout">
        <div class="vl-content-header__content">
          <div class="vl-content-header__logo-wrapper">
            <span class="vl-content-header__entity-logo vl-content-header__entity-logo--small">
              <span class="vl-content-header__entity-logo__prefix">Beleidsdomein</span>
              <span class="vl-content-header__entity-logo__title"> Omgeving</span>
            </span>
          </div>
          <div class="vl-content-header__context vl-content-header__context--has-link">
            <a class="vl-content-header__context__link" href="https://www.vlaanderen.be/veka" target="_blank">Vlaams Energie- en Klimaatagentschap</a>
          </div>
          <h2 class="vl-content-header__title vl-content-header__title--has-link">
            <a class="vl-content-header__title__link" href="/test-uw-epc">Test uw EPC</a>
          </h2>
        </div>
      </div>
    </div>
  </header>

</template>

<script>
export default {
  name: 'paginaHeader',
  data: function () {
    return {
    }
  }
}
</script>